import { PERIOD_DELIMITER } from '@glass/common/modules/strings/constants';
import filterJoin from '@glass/common/modules/strings/filterJoin';
import { RESUME_V2_FIELD } from '@glass/web/modules/resumes/fieldKeys';

const generateResumePath = (...args: Array<string>) =>
  filterJoin([RESUME_V2_FIELD, ...args], PERIOD_DELIMITER);

export default generateResumePath;
